import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useQueryClient } from "@tanstack/react-query";
import { displayNotify } from "../../../../../shared/services/Notifications/NotificationServices";

export default function useDeleteImage(guID?: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (image_id?: string) => axios.delete(`/events/${guID}/image/${image_id}/`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['events', guID] });
            displayNotify({
                status: 'success',
                title: 'Изменения сохранены',
                description: 'Изображение удалено'
            })
        }
    })
}